<h2 class="first_title">Anteprima Documento</h2>
<div class="content-page-wrapper">
    <div class="standardpanel">
        <div class="row">
            <div class="col-sm-12" style="margin-bottom: 30px;">
                <nav aria-label="Navigazione contenuti" *ngIf="breadCrumb.length > 1">
                <ol class="breadcrumb">
                    <li *ngFor="let item of breadCrumb; let i = index; let last = last" class="breadcrumb-item" [class.active]="i === activeIndex">
                        <a href="javascript:void(0)" [attr.aria-label]="'vai a ' + item.nomeFile" (click)="grabState(i)">{{item.nomeFile}}</a>
                    </li>
                </ol>
                </nav>
            </div>
        </div>
        <ul *ngIf="files.length > 0; else noPreview">
            <li *ngFor="let file of files">
                <span class="glyphicon glyphicon-file"></span>
                <span>
                    {{file.name}}
                </span>   
                <a *ngIf="canViewFile(file)" href="javascript:void(0)" [attr.aria-label]="'Apri anteprima allegato ' + file.name" (click)="openAttachmentPreview(file)">
                    <span class="glyphicon glyphicon-eye-open"></span>
                </a>
                <span 
                    *ngIf="!canViewFile(file)" 
                    class="glyphicon glyphicon-eye-close"
                    [appTooltip]="'L’anteprima non è disponibile perché il file supera le dimensioni massime consentite'" 
                    [appTooltipEnabled]="file.maxLimitExceeded">
                </span>
            </li>
        </ul>
        <ng-template #noPreview>
            <div class="row">
                <div class="col-sm-4"></div>
                <div class="col-sm-4 preview-wrapper">
                    <h4>Anteprima non disponibile, si prega di tornare alla home</h4>
                    <button style="max-width: 200px;margin: 0 auto;" [routerLink]="['/']" class="btn btn-primary btn-block">Vai alla home</button>
                </div>
                <div class="col-sm-4"></div>
            </div>
        </ng-template>
    </div>
</div>
